import {CSSProperties, CreateSheet, css} from 'aphrodite';
import Spinner, {SpinnerTheme} from 'packages/spinners/spinner.react';
import {ButtonStyleType, ButtonVariant, MakeButton} from './button';

type props = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
    loading: boolean;
    spinnerTheme?: SpinnerTheme;
    styles?: ButtonStyleType[];
    variant: ButtonVariant;
};

export default function LoadButton({children, loading, spinnerTheme, variant, ...rest}: props) {
    const dsiabled = loading || rest.disabled;
    const styles = rest.styles ? (Array.isArray(rest.styles) ? rest.styles : [rest.styles]) : [];
    return (
        <button
            {...{
                ...rest,
                styles: undefined,
                disabled: dsiabled,
                className: MakeButton(variant, Styles.button, ...styles),
            }}
        >
            {children}
            {loading && (
                <aside className={css(Styles.spinner, SpinnerBlock('inherit'))}>
                    <Spinner
                        {...{
                            theme: spinnerTheme
                                ? spinnerTheme
                                : {
                                      color: 'white',
                                      pathColor: 'transparent',
                                  },
                            height: '100%',
                        }}
                    />
                </aside>
            )}
        </button>
    );
}

const Styles = CreateSheet({
    button: {
        position: 'relative',
    },
    spinner: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        borderRadius: 'inherit',
        ':nth-child(1n) svg': {
            marginRight: 0,
        },
    },
});

const SpinnerBlock = (color: CSSProperties['backgroundColor']) => {
    return CreateSheet({
        base: {
            backgroundColor: color ? color : 'white',
        },
    }).base;
};
